import { ApportionmentCycleConsumerUnit } from 'apportionmentCycles/models/apportionmentCycleConsumerUnit';
import { TableBodyColumn } from 'ui/components/table';
import TableBodyRow from 'ui/components/table/TableBodyRow';

type Props = {
  index: number;
  apportionmentCycleConsumerUnit: ApportionmentCycleConsumerUnit;
};

export default function ApportionmentCycleConsumerUnitItem({
  index,
  apportionmentCycleConsumerUnit: {
    apportionmentCycleConsumerUnitPercentual,
    consumerUnit: {
      consumerUnitPowerDistributionUnitIdentifier,
      cooperativeMember: { cooperativeMemberLegalName },
    },
    leaseCycleCredit,
  },
}: Props): JSX.Element {
  const leaseCycleCreditOnPeak =
    (!!leaseCycleCredit?.leaseCycleCreditsOnPeak &&
      Math.round(+leaseCycleCredit?.leaseCycleCreditsOnPeak)) ||
    0;

  const leaseCycleCreditOffPeak =
    (!!leaseCycleCredit?.leaseCycleCreditsOffPeak &&
      Math.round(+leaseCycleCredit?.leaseCycleCreditsOffPeak)) ||
    0;

  return (
    <TableBodyRow dataTestId={`apportionment-cycle-row-id-${index}`}>
      <TableBodyColumn className="font-normal">{index}</TableBodyColumn>
      <TableBodyColumn className="font-normal">
        {consumerUnitPowerDistributionUnitIdentifier}
      </TableBodyColumn>
      <TableBodyColumn className="font-bold">
        {cooperativeMemberLegalName}
      </TableBodyColumn>
      <TableBodyColumn className="font-bold">
        {`${apportionmentCycleConsumerUnitPercentual} %`}
      </TableBodyColumn>
      <TableBodyColumn className="text-center">
        {leaseCycleCreditOnPeak || '-'}
      </TableBodyColumn>
      <TableBodyColumn className="text-center">
        {leaseCycleCreditOffPeak || '-'}
      </TableBodyColumn>
      <TableBodyColumn className="text-center">
        {leaseCycleCreditOnPeak + leaseCycleCreditOffPeak || '-'}
      </TableBodyColumn>
    </TableBodyRow>
  );
}
